import { ScrollReveal } from './ScrollReveal';
import { X, Check } from 'lucide-react';
import { useLang } from '@/lib/translations';

export default function CategoryReframe() {
  const { t } = useLang();
  const r = t.reframe;

  return (
    <section className="relative py-24 sm:py-32 overflow-hidden" data-testid="category-reframe-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <ScrollReveal>
          <div className="overline mb-4">{r.overline}</div>
          <h2 className="font-heading text-3xl sm:text-4xl tracking-tight font-medium text-aurocle-text mb-6">{r.title}</h2>
          <p className="text-base text-aurocle-platinum-muted max-w-2xl mb-16 leading-relaxed">{r.sub}</p>
        </ScrollReveal>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
          <ScrollReveal delay={100}>
            <div className="p-8 border border-white/6 bg-aurocle-surface rounded-lg">
              <div className="text-xs font-mono uppercase tracking-[0.2em] text-red-400/70 mb-6">{r.notLabel}</div>
              <div className="space-y-4">
                {r.nots.map((item, i) => (
                  <div key={i} className="flex items-start gap-3 text-aurocle-text-secondary">
                    <X size={16} className="text-red-400/50 mt-0.5 shrink-0" />
                    <span className="text-sm">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={200}>
            <div className="p-8 border border-aurocle-gold/15 bg-aurocle-surface rounded-lg relative overflow-hidden">
              <div className="absolute top-0 right-0 w-48 h-48 bg-aurocle-gold/5 rounded-full blur-[80px] pointer-events-none" />
              <div className="relative">
                <div className="text-xs font-mono uppercase tracking-[0.2em] text-aurocle-gold mb-6">{r.thisLabel}</div>
                <div className="space-y-4">
                  {r.this_.map((item, i) => (
                    <div key={i} className="flex items-start gap-3 text-aurocle-text">
                      <Check size={16} className="text-aurocle-gold mt-0.5 shrink-0" />
                      <span className="text-sm">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
